import { useState } from "react";
import { fetchAuthSession } from "@aws-amplify/auth";
import axios from "axios";
import { R_BANNERS } from "../../../../../constants/routes";
import { useHistory } from "react-router-dom";
import { ADMIN_BANNERS } from "../../../../../constants/api";

export const useBannerActions = () => {
  const [bannersList, setBannersList] = useState([]);
  const [isLoadingBanner, setIsLoadingBanner] = useState(false);
  const [buttonDeleteDisable, setButtonDeleteDisable] = useState(false);
  const history = useHistory();

  const createBanner = async (formData) => {
    try {
      const session = await fetchAuthSession({
        forceRefresh: true,
      });
      const userToken = session.tokens?.idToken?.toString();

      const response = await axios.post(ADMIN_BANNERS, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: userToken,
        },
      });

      return response;
    } catch (error) {
      console.log("Erro ao criar Banner: ", error);
    }
  };

  const getBanners = async () => {
    try {
      setIsLoadingBanner(true);

      const session = await fetchAuthSession({
        forceRefresh: true,
      });
      const userToken = session.tokens?.idToken?.toString();
      const response = await axios.get(ADMIN_BANNERS, {
        headers: {
          Authorization: userToken,
        },
      });

      setBannersList(response.data);
    } catch (error) {
      console.log("Erro ao buscar Banners: ", error);
    } finally {
      setIsLoadingBanner(false);
    }
  };

  const deleteBanner = async (banner_id) => {
    try {
      setButtonDeleteDisable(true);
      if (!banner_id) {
        console.log("ID do banner não fornecido");
        return;
      }

      const URL = `${ADMIN_BANNERS}?banner_id=${banner_id}`;

      const session = await fetchAuthSession({
        forceRefresh: true,
      });

      const userToken = session.tokens?.idToken?.toString();

      const response = await axios.delete(URL, {
        headers: {
          Authorization: userToken,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        history.push(R_BANNERS);
        setButtonDeleteDisable(true);
        window.location.reload();
      }

    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Erro desconhecido";
      console.log("Erro ao deletar Banner: ", errorMessage);
      setButtonDeleteDisable(false);
    }
  };

  const updateBanner = async (formData) => {
    try {
      const session = await fetchAuthSession({
        forceRefresh: true,
      });
      const userToken = session.tokens?.idToken?.toString();

      const response = await axios.put(ADMIN_BANNERS, formData, {
        headers: {
          Authorization: userToken,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        history.push(R_BANNERS);
        window.location.reload();
      }

      return response;
    } catch (error) {
      console.log("Erro ao atualizar banner: ", error);
      throw error;
    }
  };

  return {
    createBanner,
    getBanners,
    bannersList,
    isLoadingBanner,
    setBannersList,
    deleteBanner,
    updateBanner,
    buttonDeleteDisable,
  };
};
